module.exports = require("../vinyl/vinyl.js");